(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cultiva-product-banner"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__cultivaPopupInit) return;
    window.__cultivaPopupInit = true;

    var STORAGE_KEY = 'cultiva-popup-dismissed';
    var DELAY = 5000;

    function init() {
      var popup = document.querySelector('[data-cultiva-popup]');
      if (!popup) return;
      if (window.Shopify && Shopify.designMode) return;

      // try {
      //   if (sessionStorage.getItem(popup.getAttribute('data-storage-key') || STORAGE_KEY)) {
      //     return;
      //   }
      // } catch (error) {}

      var delay = parseInt(popup.getAttribute('data-delay'), 10);
      if (isNaN(delay)) delay = DELAY;

      var remaining = Math.max(0, delay - (window.performance ? performance.now() : delay));
      var closeButtons = popup.querySelectorAll('[data-cultiva-popup-dismiss]');
      var dimmer = document.querySelector('[data-cultiva-storefront-dimmer]');
      var dialog = popup.querySelector('[role="dialog"]');
      var lastFocus = null;

      function focusableEls() {
        return popup.querySelectorAll('a[href], button:not([disabled])');
      }

      function openPopup() {
        lastFocus = document.activeElement;
        popup.classList.add('is-open');
        popup.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('cultiva-popup-open');
        if (dialog) dialog.focus();
      }

      function closePopup() {
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('cultiva-popup-open');
        try {
          sessionStorage.setItem(popup.getAttribute('data-storage-key') || STORAGE_KEY, '1');
        } catch (error) {}
        if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
      }

      closeButtons.forEach(function (el) {
        el.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          closePopup();
        });
      });

      if (dimmer) {
        dimmer.addEventListener('click', function () {
          if (popup.classList.contains('is-open')) closePopup();
        });
      }

      var bannerLink = popup.querySelector('a.cultiva-product-banner');
      if (bannerLink) {
        bannerLink.addEventListener('click', function () {
          try {
            sessionStorage.setItem(popup.getAttribute('data-storage-key') || STORAGE_KEY, '1');
          } catch (error) {}
        });
      }

      document.addEventListener('keydown', function (event) {
        if (!popup.classList.contains('is-open')) return;

        if (event.key === 'Escape') {
          event.preventDefault();
          closePopup();
          return;
        }

        if (event.key !== 'Tab') return;

        var nodes = Array.prototype.slice.call(focusableEls());
        if (!nodes.length) return;

        var first = nodes[0];
        var last = nodes[nodes.length - 1];

        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      window.setTimeout(openPopup, remaining);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
